import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=788e8b1c&scoped=true&"
import script from "./approval.vue?vue&type=script&lang=js&"
export * from "./approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e8b1c",
  null
  
)

export default component.exports